import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from 'app/core/user/user.model';
import { PageResponse } from "../../shared/models/response/page-response.model";
import { ClientSearchView } from "../../shared/models/view/client-search-view.model";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    baseUrl = environment.apiBaseUrl;
    httpOptions: any = {
        withCredentials: true,
        observe: 'response' as 'response'
    };

    constructor(private _httpClient: HttpClient) {
    }

    set user(value: User) {
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    update(user: User): Observable<any> {
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                // Execute the observable
                this._user.next(response);
            })
        );
    }

    getParams(request, params): any {
        params['itemsPerPage'] = request.itemsPerPage?.toString();
        params['currentPage'] = request.currentPage?.toString();
        if (request.sort && request.sortDir) {
            // params['sort'] = request.sort;
            // params['sortDir'] = request.sortDir;
            params[`sort[${request.sort}]`] = request.sortDir;
        }

        if (request.clientId) {
            params['clientId'] = request.clientId;
        }

        if (request.salesRepID) {
            params['salesRepID'] = request.salesRepID;
        }

        if (request.clientStatusID) {
            params['clientStatusID'] = request.clientStatusID;
        }

        if (request.industryCodeID) {
            params['industryCodeID'] = request.industryCodeID;
        }

        if (request.salesResponsibleID) {
            params['salesResponsibleID'] = request.salesResponsibleID;
        }

        if (request.searchParam) {
            params['searchParam'] = request.searchParam;
        }

        if (request.sponsorLocationID) {
            params['sponsorLocationID'] = request.sponsorLocationID;
        }

        if (request.query && request.query !== '') {
            params['orLike[firstName]'] = request.query;
            params['orLike[lastName]'] = request.query;
            params['orLike[email]'] = request.query;
        }

        if (request.standardID) {
            params['standardID'] = request.standardID;
        }

        if (request.userID) {
            params['find[userID]'] = request.userID;
        }

        if (request.roleList) {
            request.roleList.map((row) => {
                params['orLike[userRoles]'] = row;
            });
        }
        return params;
    }

    getUsers(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        const httpOptionsLocal = { ...this.httpOptions, params: params };
        return this._httpClient.get<any>(`${this.baseUrl}api/data/user-profile-view`, httpOptionsLocal).pipe(
            map((users: any) => {
                const returnData = users['body'];
                const ret: PageResponse<any> = new PageResponse<any>();
                ret.items = returnData.items.map((row) => {
                    return {
                        userID: row.userID,
                        firstName: row.firstName,
                        lastName: row.lastName,
                        username: row.username,
                        email: row.email,
                        inactive: row.inactive,
                        blocked: row.blocked,
                        sponsorLocation: row.sponsorLocation ? row.sponsorLocation : null,
                    };
                });
                ret.totalItems = returnData.page.totalItems;
                ret.currentPage = request.currentPage;
                ret.itemsPerPage = request.itemsPerPage;
                return ret;
            })
        );
    }

    updateSignature(user: User): Observable<any> {
        return this._httpClient.post<User>(`${this.baseUrl}api/data/user-profile/update-user-signature`, user).pipe(
            map((response) => {
                // Execute the observable
                // this._user.next(user);
            })
        );
    }
}
